// IconButton.tsx
import React, { ReactNode } from "react";

interface IconButtonProps {
  icon: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  style?: Record<string, string>;
  type?: "button" | "submit" | "reset" | undefined;
  size?: "small" | "medium" | "large";
}

const IconButton = ({
  icon,
  onClick,
  disabled = false,
  style = {},
  size = "medium",
  type = "button",
}: IconButtonProps) => {
  const sizeClasses = {
    small: "w-8 h-8 text-sm",
    medium: "w-10 h-10 text-base",
    large: "w-12 h-12 text-lg",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={`flex items-center justify-center rounded-md 
        bg-white
        disabled:bg-gray-400 disabled:cursor-not-allowed 
        ${sizeClasses[size]}`}
    >
      {icon}
    </button>
  );
};

export default IconButton;
